import { Formik } from "formik";
import { object, ref, string } from "yup";

import { useKeystone, usePolicyDetail } from "data/ss-data-hooks";
import { isError } from "data/ss-error";
import EditEmailForm from "pages/settings/common/edit-email-form";
import { logException, trackEvent } from "utils";

const initialValues = {
  email: "",
  confirmEmail: "",
};

const schema = object().shape({
  email: string().required("Email required.").email("Enter a valid email."),
  confirmEmail: string()
    .oneOf([ref("email"), undefined], "Email address must match.")
    .required("Email address must match."),
});

type EditDocumentsEmailModalProps = {
  policyId: string;
  show: boolean;
  handleClose: () => void;
  onEditDocumentsSuccess: () => void;
};

const EditDocumentsEmailModal = ({
  policyId,
  show,
  handleClose,
  onEditDocumentsSuccess,
}: EditDocumentsEmailModalProps) => {
  const keystone = useKeystone();
  const { mutate: refreshPolicy } = usePolicyDetail(policyId);

  const handleSubmit = async (
    { email },
    { resetForm, setSubmitting, setStatus },
  ) => {
    try {
      setSubmitting(true);
      const updatePaperlessDocumentsEmailResponse =
        await keystone.updatePaperlessDocsEmail(policyId, email);

      if (isError(updatePaperlessDocumentsEmailResponse)) {
        throw updatePaperlessDocumentsEmailResponse;
      } else {
        trackEvent("Email address updated", { paperlessType: "documents" });
        refreshPolicy();
        onEditDocumentsSuccess();
        resetForm();
      }

      setSubmitting(false);
    } catch (err) {
      logException(err);
      setStatus(err.message.split("error: ")[1]);
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
      enableReinitialize
    >
      <EditEmailForm
        handleClose={handleClose}
        show={show}
        heading="Update paperless email address"
      />
    </Formik>
  );
};

export default EditDocumentsEmailModal;
